import React from "react"
import ShopPage from "../components/ShopPage/ShopPage"
import Utils from "../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"
import { getSubCategories } from "../contentfunctions/shop.js"

const AccessoriesIndexPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage(
    "en",
    "/accessories",
    location.state,
    location.search
  )
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const contentMap = Utils.ContentListToMap(data.shopContent.item.content)
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const categories = getSubCategories(data.categories.edges, false, {
          filter: "Accessories",
        })

        return (
          <ShopPage
            title={contentMap.seo_title_accessories.value}
            description={contentMap.seo_description_accessories.value}
            breadCrumbs={["menu_home", "menu_accessories"]}
            mainCategories={categories.mainCategories}
            subCategories={categories.subCategories}
            breadCrumb={"accessories"}
            location={location}
            originPage="accessories"
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            products={data.products.edges}
            keywords={Utils.GetKeywordsFromTags(data.shopContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default AccessoriesIndexPage

const pageQuery = graphql`
  {
    commonContent: commonContentEngb {
      item {
        key
        content {
          key
          value
        }
      }
    }

    shopContent: shopContentEngb {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    categories: allCategoriesEngb(sort: { fields: [item___key], order: ASC }) {
      edges {
        node {
          item {
            id
            key
            content {
              key
              value
            }
            page_children {
              id
              key
              content {
                key
                value
              }
            }
          }
        }
      }
    }

    products: allProductsEngb(
      sort: { fields: [item___collectionIndex], order: ASC }
    ) {
      edges {
        node {
          item {
            id
            key
            slug
            priority
            private
            data {
              quantity
              price {
                value
                discount_value
                currency
              }
            }
            categories {
              key
              content {
                key
                value
              }
            }
            content {
              key
              value
            }
            variation_sequences {
              data {
                quantity
                price {
                  value
                  discount_value
                  currency
                }
              }
            }
          }
        }
      }
    }
  }
`
